<template>
  <!-- On outh -->
  <div class="wrapper" @click.self="close">
    <div class="share-widget">
      <div class="share-header">
        <div class="share-title">Share with</div>
        <button class="share-close" @click="close">&times;</button>
      </div>
      <div class="share-app">
        <ShareNetwork
          network="facebook"
          :url="share_data.url"
          :title="share_data.title"
          :description="share_data.description"
        >
          <button class="facebook-btn">
            <img src="@/assets/share_icon/facebook.svg" />
          </button>
        </ShareNetwork>
        <ShareNetwork
          network="email"
          :url="share_data.url"
          :title="share_data.title"
          :description="share_data.description"
        >
          <button class="email-btn">
            <img src="@/assets/share_icon/envelope.svg" />
          </button>
        </ShareNetwork>
        <ShareNetwork
          network="linkedIn"
          :url="share_data.url"
          :title="share_data.title"
          :description="share_data.description"
        >
          <button class="linkedin-btn">
            <img src="@/assets/share_icon/linkedin.svg" />
          </button>
        </ShareNetwork>

        <ShareNetwork
          network="whatsApp"
          :url="share_data.url"
          :title="share_data.title"
          :description="share_data.description"
        >
          <button class="whatsapp-btn">
            <img src="@/assets/share_icon/whatsapp.svg" />
          </button>
        </ShareNetwork>
        <div>
          <button class="share-btn" @click="sharePhone()">
            <img src="@/assets/share_icon/share.svg" />
          </button>
        </div>
      </div>
      <div class="share-link-title">Or share with link</div>
      <div class="share-link-widget">
        <div class="share-link">
          <input
            type="text"
            readonly
            v-model="share_data.url"
            class="link-input"
          />
          <button
            class="btn-copy"
            v-clipboard:copy="share_data.url"
            v-clipboard:success="clipboardSuccessHandler"
            v-clipboard:error="clipboardErrorHandler"
          >
            <img src="@/assets/icons/copy.svg" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "share-helper",
  data() {
    return {
      share_data: {
        url: "",
        title: "",
        description: "",
      },
      show_modal: false,
    };
  },
  props: {
    // "title", "description", "visible"
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: "",
    },
  },
  computed: {},
  mounted() {
    let vm = this;
    if (vm.url) {
      vm.share_data.url = vm.url;
    } else {
      vm.share_data.url = window.location.href;
    }
    vm.share_data.title = vm.title;
    vm.share_data.description = vm.description;
  },
  methods: {
    clipboardSuccessHandler({ value, event }) {
      let vm = this;
      vm.$notify({
        group: "status",
        title: "Important message",
        text: "Link copied",
        type: "success",
        duration: 3000,
      });
    },

    clipboardErrorHandler({ value, event }) {
      let vm = this;
      vm.$notify({
        group: "status",
        title: "Something wrong",
        text: "Error while copying, Please try again.",
        type: "warn",
        duration: 3000,
      });
    },
    sharePhone() {
      let vm = this;
      if (navigator.share) {
        navigator
          .share({
            title: vm.share_data.title,
            text: vm.share_data.description,
            url: vm.share_data.url,
          })
          .then(() => vm.close())
          .catch((err) => console.error(err));
      } else {
        window.location = `mailto:?subject=${vm.share_data.title}&body=${vm.share_data.description}%0A${vm.share_data.url}`;
      }
    },
    close() {
      this.$emit("onClose", null);
    },
  },
  watch: {
    visible: function (val) {
      this.show_modal = val;
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.wrapper {
  width: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: #000000d9;
  z-index: 9999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  .share-widget {
    width: 500px;
    background: #fff;
    border-radius: 5px;
    .share-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      padding: 0px 15px;
      .share-close {
        font-size: 25px;
      }
    }
    .share-app {
      display: flex;
      justify-content: space-between;
      padding: 10px 15px;
      .facebook-btn {
        background: rgba(157, 157, 157, 0.04);
        border: 1px solid #ddd;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        outline: none;
        font-weight: 800;
        height: 60px;
        width: 60px;
        img {
          width: 25px;
        }
      }
      .email-btn {
        background: rgba(157, 157, 157, 0.04);
        border: 1px solid #ddd;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        outline: none;
        font-weight: 800;
        height: 60px;
        width: 60px;
        img {
          width: 25px;
        }
      }
      .linkedin-btn {
        background: rgba(157, 157, 157, 0.04);
        border: 1px solid #ddd;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        outline: none;
        font-weight: 800;
        height: 60px;
        width: 60px;
        img {
          width: 25px;
        }
      }
      .whatsapp-btn {
        background: rgba(157, 157, 157, 0.04);
        border: 1px solid #ddd;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        outline: none;
        font-weight: 800;
        height: 60px;
        width: 60px;
        img {
          width: 25px;
        }
      }
      .share-btn {
        background: rgba(157, 157, 157, 0.04);
        border: 1px solid #ddd;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        outline: none;
        font-weight: 800;
        height: 60px;
        width: 60px;
        img {
          width: 25px;
        }
      }
    }
    .share-link-title {
      text-align: center;
      padding: 10px 15px;
      color: rgba(61, 90, 128, 0.5);
    }
    .share-link-widget {
      padding: 16px 15px;
      .share-link {
        display: flex;
        background: rgba(157, 157, 157, 0.04);
        border-radius: 16px;
        .link-input {
          height: 50px;
          width: 100%;
          outline: none;
          padding: 0px 15px;
          color: rgba(61, 90, 128, 0.5);
        }
        .btn-copy {
          padding: 0px 10px;
          font-weight: 800;
        }
      }
    }
  }
}
</style>